
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { HelmetProvider } from 'react-helmet-async';

// Use requestIdleCallback for non-critical initializations
const initialize = () => {
  const root = createRoot(document.getElementById("root")!);
  root.render(
    <HelmetProvider>
      <App />
    </HelmetProvider>
  );
};

// Use requestIdleCallback for non-critical work, with fallback for browsers that don't support it
if ('requestIdleCallback' in window) {
  window.requestIdleCallback(initialize);
} else {
  // Fallback for browsers that don't support requestIdleCallback
  setTimeout(initialize, 1);
}
